var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatTeardropDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1889_12193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V11.625C3.75 9.33751 4.6587 7.14371 6.2762 5.5262C7.89371 3.9087 10.0875 3 12.375 3C13.5077 3 14.6292 3.22309 15.6756 3.65654C16.7221 4.08999 17.6729 4.7253 18.4738 5.5262C19.2747 6.32711 19.91 7.27792 20.3435 8.32436C20.7769 9.37079 21 10.4923 21 11.625C21 12.7577 20.7769 13.8792 20.3435 14.9256C19.91 15.9721 19.2747 16.9229 18.4738 17.7238C17.6729 18.5247 16.7221 19.16 15.6756 19.5935C14.6292 20.0269 13.5077 20.25 12.375 20.25Z",
    stroke: "#1859B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 13.125C12.9963 13.125 13.5 12.6213 13.5 12C13.5 11.3787 12.9963 10.875 12.375 10.875C11.7537 10.875 11.25 11.3787 11.25 12C11.25 12.6213 11.7537 13.125 12.375 13.125Z",
    fill: "#1859B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.125C8.87132 13.125 9.375 12.6213 9.375 12C9.375 11.3787 8.87132 10.875 8.25 10.875C7.62868 10.875 7.125 11.3787 7.125 12C7.125 12.6213 7.62868 13.125 8.25 13.125Z",
    fill: "#1859B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.125C17.1213 13.125 17.625 12.6213 17.625 12C17.625 11.3787 17.1213 10.875 16.5 10.875C15.8787 10.875 15.375 11.3787 15.375 12C15.375 12.6213 15.8787 13.125 16.5 13.125Z",
    fill: "#1859B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1889_12193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTeardropDots);
export default __webpack_public_path__ + "static/media/ChatTeardropDots.8aacf6437b2b233618caf7b3b1ffa8ee.svg";
export { ForwardRef as ReactComponent };